// extracted by mini-css-extract-plugin
export var accordionRichText = "AccordionContent-module--accordionRichText--a7adb";